export default __webpack_public_path__ + "static/media/icon.e47741c2.png";